module.exports = __webpack_public_path__ + "media/img/uploads/solutions-thumb-08-e106b57011c2078d1d5dbdfb70f98260.jpg";